import React from "react";
import { AnalyticsEvent } from "../../analytics/track";
import { useAnalytics } from "../../hooks/analytics";
import { useSearchQuery } from "../../providers/search_query_provider";
import { useSearchRouting } from "../../providers/search_routing_provider";
import type { Question } from "../../types";

type SearchQuestionProps = {
  question: Question;
};

export default function SearchQuestion({ question }: SearchQuestionProps) {
  const { track } = useAnalytics();
  const { normalizedQuery, setQuery } = useSearchQuery();
  const { routing } = useSearchRouting();

  return (
    <li key={question.text}>
      <button
        type="button"
        className="dewey--search--question"
        onClick={() => {
          track(AnalyticsEvent.SEARCH_RESULTS_CLICKED, {
            query: normalizedQuery,
            query_type: routing,
            result_type: "question",
            result_value: question,
          });
          setQuery(question.text, true);
        }}
      >
        {question.text}
      </button>
    </li>
  );
}
